// @ts-nocheck
/* eslint-disable */
export const transparentLocationIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><g fill="#798693"><path d="M17.183 7.042C16.308 3.192 12.95 1.458 10 1.458h-.008c-2.942 0-6.309 1.725-7.184 5.575-.975 4.3 1.659 7.942 4.042 10.234A4.53 4.53 0 0 0 10 18.542a4.5 4.5 0 0 0 3.142-1.275c2.383-2.292 5.016-5.925 4.041-10.225" opacity=".4"/><path d="M10 11.217a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25"/></g></svg>`,
    name: 'transparent-location' as const
};